import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { TutorialsPage } from './pages/TutorialsPage';
import { WorkshopsPage } from './pages/WorkshopsPage';
import { ShopPage } from './pages/ShopPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { LoginForm } from './components/LoginForm';
import { RegisterForm } from './components/RegisterForm';
import { ForgotPasswordForm } from './components/ForgotPasswordForm';
import { ResetPasswordForm } from './components/ResetPasswordForm';
import { AdminPage } from './pages/AdminPage';
import { TutorialViewerPage } from './pages/TutorialViewerPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import { CheckoutPage } from './pages/CheckoutPage';
import { CategoryPage } from './pages/CategoryPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { PaymentFailurePage } from './pages/PaymentFailurePage';
import { MyOrdersPage } from './pages/MyOrdersPage';
import { EditProfilePage } from './pages/EditProfilePage';
import { SearchResultsPage } from './pages/SearchResultsPage';
import { DealsPage } from './pages/DealsPage';
import { ChatPage } from './pages/ChatPage';
import { FreeToolsPage } from './pages/FreeToolsPage';
import { ProtectedRoute } from './components/ProtectedRoute';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'tutorials',
        children: [
          {
            index: true,
            element: <TutorialsPage />,
          },
          {
            path: ':id',
            element: (
              <ProtectedRoute>
                <TutorialViewerPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: 'workshops',
        element: <WorkshopsPage />,
      },
      {
        path: 'shop',
        element: <ShopPage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
      {
        path: 'login',
        element: <LoginForm />,
      },
      {
        path: 'register',
        element: <RegisterForm />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPasswordForm />,
      },
      {
        path: 'reset-password',
        element: <ResetPasswordForm />,
      },
      {
        path: 'admin',
        element: (
          <ProtectedRoute>
            <AdminPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'terms',
        element: <TermsOfUsePage />,
      },
      {
        path: 'checkout',
        element: (
          <ProtectedRoute>
            <CheckoutPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'payment',
        children: [
          {
            path: 'success',
            element: (
              <ProtectedRoute>
                <PaymentSuccessPage />
              </ProtectedRoute>
            ),
          },
          {
            path: 'failure',
            element: <PaymentFailurePage />,
          },
        ],
      },
      {
        path: 'category/:category',
        element: <CategoryPage />,
      },
      {
        path: 'my-orders',
        element: (
          <ProtectedRoute>
            <MyOrdersPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'deals',
        element: <DealsPage />,
      },
      {
        path: 'edit-profile',
        element: (
          <ProtectedRoute>
            <EditProfilePage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'search',
        element: <SearchResultsPage />,
      },
      {
        path: 'chat',
        element: <ChatPage />,
      },
      {
        path: 'free-tools',
        element: <FreeToolsPage />,
      },
    ],
  },
]);

export const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />;
}; 